import { Util } from '@libs/utilities/util';
import { ObjectStorage } from '@libs/libraries/shared';

import { EnumAiImageGeneratorModule, IAiEditorStates, TypeAiEditorModule, TypeAiEditorModuleItem, TypeAiEditorModuleItemKey } from './ai-editor.interface';


/**------------------------------------------------------
 * AI Image Generator Storage
 */
export class AiImageGeneratorStorageHelper {

	constructor(
		private storageAccessHelper: ObjectStorage<IAiEditorStates>
	) {}


	/**------------------------------------------------------
	 * Save & Load AI Generator State
	 */
	saveAiImageGeneratorState(moduleName: EnumAiImageGeneratorModule, state: TypeAiEditorModule): void {
		this.storageAccessHelper.setStorageObject<EnumAiImageGeneratorModule>(moduleName, state);
	}

	assignAiImageGeneratorState(moduleName: EnumAiImageGeneratorModule, stateRef: TypeAiEditorModule): boolean {

		//0 - try to load the value from the local storage
		const state: Record<string, any> = this.storageAccessHelper.getStorageObject<EnumAiImageGeneratorModule>(moduleName);
		if (Util.Basic.isUndefined(state)) return false;

		//1 - set the loaded values as the new state
		stateRef = Util.Basic.deepAssignPartial(stateRef, state, false);
		return true;
	}

	loadAiImageGeneratorState(pageName: EnumAiImageGeneratorModule): TypeAiEditorModule {

		//0 - try to load the value from the local storage
		const state: TypeAiEditorModule = this.storageAccessHelper.getStorageObject<EnumAiImageGeneratorModule>(pageName);
		if (Util.Basic.isUndefined(state)) return null;

		//1 - return the state
		return state;
	}


	/**------------------------------------------------------
	 * Save & Load AI Generator State Item
	 */
	saveAiImageGeneratorStateItem(moduleName: EnumAiImageGeneratorModule, itemKey: TypeAiEditorModuleItemKey, state: TypeAiEditorModuleItem): void {
		this.storageAccessHelper.setStorageItem<EnumAiImageGeneratorModule, TypeAiEditorModuleItemKey>(moduleName, itemKey, state);
	}

	assignAiImageGeneratorStateItem(moduleName: EnumAiImageGeneratorModule, itemKey: TypeAiEditorModuleItemKey, stateRef: TypeAiEditorModuleItem): boolean {

		//0 - try to load the value from the local storage
		const stateItem: any = this.storageAccessHelper.getStorageItem<EnumAiImageGeneratorModule, TypeAiEditorModuleItemKey>(moduleName, itemKey);
		if (Util.Basic.isUndefined(stateItem)) return false;

		//1 - set the loaded values as the new state
		stateRef = Util.Basic.deepAssignPartial(stateRef, stateItem, false);
		return true;
	}

	loadAiImageGeneratorStateItem(moduleName: EnumAiImageGeneratorModule, itemKey: TypeAiEditorModuleItemKey): TypeAiEditorModuleItem | null {

		//0 - try to load the value from the local storage
		const stateItem: any = this.storageAccessHelper.getStorageItem<EnumAiImageGeneratorModule, TypeAiEditorModuleItemKey>(moduleName, itemKey);
		if (Util.Basic.isUndefined(stateItem)) return null;

		//1 - return the state
		return stateItem;
	}
}
